import { AppTile } from './app-tile';

export class LanguageTermAppTile {
  public AppTile: AppTile;
  public AppTileId: number;
  public LanguageTermId: string;

  constructor(opt?: Partial<LanguageTermAppTile>) {
    Object.assign(this, opt);
  }
}
